import React, { useEffect, useState } from 'react';
import axios from 'axios';
import MDEditor from '@uiw/react-md-editor';
import '@uiw/react-markdown-preview/markdown.css';

const API_BASE_URL = (process.env.REACT_APP_API_URL || window.location.origin || '').replace(/\/$/, '');

const JCalTermsOfService = () => {
    const [tos, setTos] = useState(null);
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        let active = true;

        axios.get(`${API_BASE_URL}/flutter/tos?app=jcal`)
            .then((res) => {
                if (!active) return;
                setTos(res.data);
                setStatus('ready');
            })
            .catch(() => {
                if (!active) return;
                setStatus('error');
            });

        return () => {
            active = false;
        };
    }, []);

    return (
        <main style={styles.page}>
            <section style={styles.shell}>
                <a href="/jcal" style={styles.brandLink} aria-label="Go to JCAL home">
                    <img src="/jcal-logo.png" alt="" style={styles.logo} />
                    <span style={styles.brandName}>JCAL</span>
                </a>

                <div style={styles.header}>
                    <h1 style={styles.title}>Terms of Service</h1>
                    {tos?.effective_date && (
                        <p style={styles.meta}>
                            Effective {new Date(tos.effective_date).toLocaleDateString(undefined, {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric',
                            })}
                        </p>
                    )}
                </div>

                {status === 'loading' && <p style={styles.message}>Loading terms of service...</p>}
                {status === 'error' && (
                    <p style={styles.message}>
                        The terms of service are not available yet. Please check back soon or contact info@jcal.app.
                    </p>
                )}
                {status === 'ready' && (
                    <div data-color-mode="light" style={styles.content}>
                        <MDEditor.Markdown source={tos.content} />
                    </div>
                )}
            </section>
        </main>
    );
};

const styles = {
    page: {
        minHeight: '100vh',
        background: '#f6f8fa',
        color: '#1a2236',
        padding: '32px 16px',
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    },
    shell: {
        width: 'min(880px, 100%)',
        margin: '0 auto',
        background: '#ffffff',
        border: '1px solid #dde3f0',
        borderRadius: 8,
        padding: '28px',
    },
    brandLink: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        color: '#1a2236',
        textDecoration: 'none',
        marginBottom: 28,
    },
    logo: {
        width: 36,
        height: 36,
        objectFit: 'contain',
    },
    brandName: {
        fontSize: 20,
        fontWeight: 800,
    },
    header: {
        borderBottom: '1px solid #e5eaf5',
        marginBottom: 24,
        paddingBottom: 16,
    },
    title: {
        margin: 0,
        fontSize: 34,
        lineHeight: 1.15,
        color: '#0f1c35',
    },
    meta: {
        margin: '8px 0 0',
        color: '#64748b',
        fontSize: 14,
    },
    content: {
        fontSize: 16,
        lineHeight: 1.65,
    },
    message: {
        color: '#64748b',
        fontSize: 16,
        lineHeight: 1.6,
    },
};

export default JCalTermsOfService;
